var _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 3.7778,
    x2: 22.9995,
    y2: 3.7778,
    stroke: "white",
    strokeWidth: 2.44439
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 11.1108,
    x2: 22.9995,
    y2: 11.1108,
    stroke: "white",
    strokeWidth: 2.44439
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1.00098,
    y1: 18.2778,
    x2: 23.001,
    y2: 18.2778,
    stroke: "white",
    strokeWidth: 2.44439
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHamburgerMenu);
export default __webpack_public_path__ + "static/media/mobile-hamburger-menu.62b778fab21b2e14bae81a7fce6eae6a.svg";
export { ForwardRef as ReactComponent };